'use es6';

import PreviewAPI from '../api/PreviewAPI';
import { ActionTypes } from '../constants/AppConstants';
const previewAPI = new PreviewAPI();
export default {
  previewWebsite(websiteUrl) {
    return dispatch => {
      dispatch({
        type: ActionTypes.FETCH_PREVIEW_STARTED
      });
      previewAPI.getDesktopPreview(websiteUrl).then(response => dispatch({
        type: ActionTypes.DESKTOP_WEBSITE_PREVIEWED,
        payload: response.responseJSON
      }), () => dispatch({
        type: ActionTypes.DESKTOP_WEBSITE_PREVIEWED_ERROR
      }));
      previewAPI.getMobilePreview(websiteUrl).then(response => dispatch({
        type: ActionTypes.MOBILE_WEBSITE_PREVIEWED,
        payload: response.responseJSON
      }), () => dispatch({
        type: ActionTypes.MOBILE_WEBSITE_PREVIEWED_ERROR
      }));
    };
  }

};